import type { RaRecord } from "react-admin";

import {
  formatNarrationIts,
  formatNarrationRupee,
  formatNarrationTransactionId,
} from "./receipt-narration-format";

export type NiyaazReceiptNarrationInput = {
  HOFId?: unknown;
  HOFName?: unknown;
  amount?: unknown;
  mode?: unknown;
  transactionId?: unknown;
  paymentRef?: unknown;
  formNo?: unknown;
  markaz?: unknown;
  eventName?: unknown;
};

export type NiyaazReceiptNarrationOptions = {
  includeItsNo?: boolean;
  includeName?: boolean;
  includeAmount?: boolean;
  includePaymentMode?: boolean;
  includeTransactionId?: boolean;
  includeFormNo?: boolean;
  includeEvent?: boolean;
};

function parseAmount(v: unknown): number {
  const n = Number(v);
  return Number.isFinite(n) ? Math.round(n) : 0;
}

/** ITS, name, paid amount, payment mode, txn id, form/event — Tally export (not printed on receipt). */
export function formatNiyaazReceiptNarration(
  input: NiyaazReceiptNarrationInput,
  options?: NiyaazReceiptNarrationOptions
): string {
  const includeItsNo = options?.includeItsNo ?? true;
  const includeName = options?.includeName ?? true;
  const includeAmount = options?.includeAmount ?? true;
  const includePaymentMode = options?.includePaymentMode ?? true;
  const includeTransactionId = options?.includeTransactionId ?? true;
  const includeFormNo = options?.includeFormNo ?? true;
  const includeEvent = options?.includeEvent ?? true;

  const itsPart = includeItsNo ? formatNarrationIts(input.HOFId) : "";
  const name = includeName ? String(input.HOFName ?? "").trim() : "";
  const paidAmount = includeAmount ? formatNarrationRupee(parseAmount(input.amount)) : "";
  const paymentMode = includePaymentMode
    ? String(input.mode ?? "")
        .trim()
        .toUpperCase()
    : "";
  const txnPart = includeTransactionId
    ? formatNarrationTransactionId(input.transactionId ?? input.paymentRef)
    : "";
  const formNo = includeFormNo ? String(input.formNo ?? "").trim() : "";
  const eventOrMarkaz = includeEvent
    ? String(input.eventName ?? "").trim() || String(input.markaz ?? "").trim()
    : "";

  return [itsPart, name, paidAmount, paymentMode, txnPart, formNo, eventOrMarkaz]
    .filter((part) => part !== "")
    .join(", ");
}

export function formatNiyaazReceiptNarrationFromRecord(
  rec: RaRecord,
  options?: NiyaazReceiptNarrationOptions
): string {
  const event = rec.event as { name?: string } | undefined;
  return formatNiyaazReceiptNarration(
    {
      HOFId: rec.HOFId,
      HOFName: rec.HOFName,
      amount: rec.amount,
      mode: rec.mode,
      transactionId: rec.transactionId,
      paymentRef: rec.paymentRef,
      formNo: rec.formNo,
      markaz: rec.markaz,
      eventName: event?.name,
    },
    options
  );
}
